import { styled } from 'styled-components';
import { colors, getFontSize } from '../../../abstracts';
import { createTransition, getStatusColor } from '../utils';
import { dontForwardProps } from '../../../util';
export const HelperText = styled.span.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-5yv6tm-0"
})(["font-size:", ";padding:0.25rem 0.75rem;color:", ";", ""], getFontSize(1), ({
  fieldStatus
}) => getStatusColor('color')[fieldStatus] || colors.neutralDeeper, createTransition({
  properties: ['color']
}));